import { useNavigate } from 'react-router-dom';

type GoParams = {
  path: string;
  state?: any; // 添加state参数支持
};

// 跳转对象
export function useGo() {
  const navigate = useNavigate();
  const go = (params: GoParams) => {
    const { path, state } = params;
    navigate(path, { state });
  };
  return {
    go,
  };
}
